import axios from "axios"

export const getVerificar = async () => {
    return axios.get(`api/Home/VerificarCarga`)
}


export const consultarComerciosDeUsuario = async () => {
    return axios.get(`api/Home/ConsultarComerciosDeUsuario`)
}

